import React from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';

import { AppLayout } from 'src/hoc/appLayout/AppLayout';

import { ROUTE } from 'src/constants/routes';

import { Home } from 'src/features/home/Home';
import { SignUp } from 'src/features/signUp/SignUp';
import { RegisterSuccess } from 'src/features/registerSuccess/RegisterSuccess';
import { SignIn } from 'src/features/signIn/SignIn';
import { TwoFA } from 'src/features/twoFA/TwoFA';
import { ForgotPassword } from 'src/features/forgotPassword/ForgotPassword';
import { ForgotPasswordSuccess } from 'src/features/forgotPasswordSuccess/ForgotPasswordSuccess';
import { ResetPassword } from 'src/features/resetPassword/ResetPassword';
import { PasswordSuccess } from 'src/features/passwordSuccess/PasswordSuccess';
import { ErrorPage } from 'src/features/errorPage/ErrorPage';
import { Withdrawal } from 'src/features/withdrawal/Withdrawal';
import { Contacts } from 'src/features/contacts/Contacts';
import { PrivacyPolicy } from 'src/features/policies/privacyPolicy/PrivacyPolicy';
import { Markets } from 'src/features/markets/Markets';
import { TradingSessions } from 'src/features/tradingSessions/TradingSessions';
import { Instruments } from 'src/features/instruments/Instruments';
import { AboutCompany } from 'src/features/aboutCompany/AboutCompany';
import { Platform } from 'src/features/platform/Platform';
import { WithdrawalSuccess } from 'src/features/withdrawalSuccess/WithdrawalSuccess';

import './app.scss';
import { ReturnPolicy } from 'src/features/policies/returnPolicy/ReturnPolicy';
import { ClientAgreement } from 'src/features/policies/clientAgreement/ClientAgreement';

export const App = () => {
  return (
    <div className="app">
      <Routes>
        <Route element={<AppLayout />}>
          <Route path={ROUTE.HOME} element={<Home />} />
          <Route path={ROUTE.AUTH.SIGNUP} element={<SignUp />} />
          <Route path={ROUTE.AUTH.SIGNUP_SUCESS} element={<RegisterSuccess />} />
          <Route path={ROUTE.AUTH.SIGNIN} element={<SignIn />} />
          <Route path={ROUTE.AUTH.TWO_FA} element={<TwoFA />} />
          <Route path={ROUTE.AUTH.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTE.AUTH.FORGOT_PASSWORD_SUCCESS} element={<ForgotPasswordSuccess />} />
          <Route path={ROUTE.AUTH.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ROUTE.AUTH.RESET_PASSWORD_NO_LNG} element={<ResetPassword />} />
          <Route path={ROUTE.AUTH.RESET_PASSWORD_SUCCESS} element={<PasswordSuccess />} />

          <Route path={ROUTE.WITHDRAWAL.CREATED} element={<Withdrawal />} />
          <Route path={ROUTE.WITHDRAWAL.SUCCESS} element={<WithdrawalSuccess />} />
          <Route path={ROUTE.WITHDRAWAL.ERROR} element={<ErrorPage />} />

          <Route path={ROUTE.WITHDRAWAL_NO_LNG.CREATED} element={<Withdrawal />} />
          <Route path={ROUTE.WITHDRAWAL_NO_LNG.SUCCESS} element={<WithdrawalSuccess />} />
          <Route path={ROUTE.WITHDRAWAL_NO_LNG.ERROR} element={<ErrorPage />} />

          <Route path={ROUTE.CONTACTS} element={<Contacts />} />

          <Route path={ROUTE.PRIVACY_POLICY} element={<PrivacyPolicy />} />
          <Route path={ROUTE.RETURN_POLICY} element={<ReturnPolicy />} />
          <Route path={ROUTE.CLIENT_AGREEMENT} element={<ClientAgreement />} />

          <Route path={ROUTE.MARKETS.MARKETS} element={<Markets />} />
          <Route path={ROUTE.MARKETS.TRADING_SESSION} element={<TradingSessions />} />
          <Route path={ROUTE.MARKETS.INSTRUMENTS} element={<Instruments />} />

          <Route path={ROUTE.PLATFORM} element={<Platform />} />
          <Route path={ROUTE.ABOUT_COMPANY} element={<AboutCompany />} />
        </Route>
        <Route path="*" element={<Navigate to={ROUTE.HOME} />} />
      </Routes>
    </div>
  );
};
